import actions from 'actions'

import type { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const closeLoginModal: CheckoutActionCreator = (e?: MouseEvent) => (dispatch) => {
  e?.stopPropagation()

  dispatch(actions.loginVisibilityChange(false))
}
